import React, { useState, useEffect } from 'react';
import { Check, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const CONSENT_KEY = 'vt_cookie_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem(CONSENT_KEY);
    if (!choice) setVisible(true);
    if (choice && typeof window.gtag === 'function') {
      window.gtag('consent', 'update', { analytics_storage: choice === 'accepted' ? 'granted' : 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
    }
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted',
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied'
      });
      // The initial page view may have fired before consent was granted.
      // Record the current page once the visitor explicitly opts in.
      window.gtag('event', 'page_view', {
        page_location: window.location.href,
        page_title: document.title
      });
    }
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    window.gtag?.('consent', 'update', { analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] px-3 pb-3 md:px-6 md:pb-4">
      <div className="max-w-4xl mx-auto bg-primary text-primary-foreground border border-border shadow-2xl">
        <div className="px-4 py-3 md:px-5 md:py-3 flex flex-col sm:flex-row items-start sm:items-center gap-3 md:gap-4">
          <p className="flex-1 font-body text-xs md:text-sm leading-snug">
            Við notum vafrakökur (Google Analytics) til að greina umferð og bæta upplifun.{' '}
            <Link to="/personuvernd" className="underline underline-offset-2 hover:opacity-70 whitespace-nowrap">Nánar</Link>
          </p>
          <div className="flex items-center gap-2 shrink-0">
            <button
              onClick={accept}
              className="inline-flex items-center gap-1.5 bg-primary-foreground text-primary px-4 py-2 font-mono text-[10px] uppercase tracking-[0.15em] hover:opacity-90 transition-opacity whitespace-nowrap"
            >
              <Check className="w-3 h-3" /> Samþykkja
            </button>
            <button
              onClick={decline}
              className="inline-flex items-center gap-1.5 border border-primary-foreground/40 text-primary-foreground px-4 py-2 font-mono text-[10px] uppercase tracking-[0.15em] hover:bg-primary-foreground/10 transition-colors whitespace-nowrap"
            >
              <X className="w-3 h-3" /> Hafna
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}